import DataTable from "react-data-table-component";
import { SyncLoader } from "react-spinners";
import NoDataPrompt from "../NoDataPrompt/NoDataPrompt";
import "./Table.css";

const parseDate = (dateString) => {
    if (dateString === 'None' || dateString === 'N/A') {
        return null;
    }

    if (dateString.includes('-')) {
        // MM-DD-YYYY format
        const parts = dateString.split('-');
        const month = parseInt(parts[0]);
        const day = parseInt(parts[1]);
        const year = parseInt(parts[2]);
        return new Date(year, month - 1, day);
    } else {
        // Jan 10, 2023 format
        const parts = dateString.split(' ');
        const month = parts[0];
        const day = parseInt(parts[1].replace(',', ''));
        const year = parseInt(parts[2]);
        const monthIndex = monthToIndex(month);
        if (monthIndex === -1) {
            return null;
        }
        return new Date(year, monthIndex, day);
    }
};

const monthToIndex = (month) => {
    const months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];
    return months.indexOf(month);
};

export default function Table({
    tableHeaders,
    headerSelector,
    tableData,
    ActionBtn,
    ViewBtn,
    PendingBtn,
    showLoader,
    withActionData,
    onRowClicked,
    SaleBtn,
    DepositedBtn,
    InvVarianceBtn,
    CashVarianceBtn,
    TotalVarianceBtn,
    SaleBillingBtn,
    checkBtn,
    handleOnCheck,
    OngoingPOBadges,
    branchStatus,
    cashVariance,
    tableType,
    PaymentBtn,
    newTabBtn,
    totalItems,
    currentPage,
    itemsPerPage,
    handlePageChange
}) {
    const columns = tableHeaders.map((header, index) => {
        if (header === "-") {
            return {
                name: "",
                selector: (row) => row[headerSelector[index]],
                button: true,
                cell: ViewBtn,
                width: "8rem",
                reorder: false,
                wordWrap: "break-word",
            };
        } else if (header === "+") {
            return {
                name: "",
                selector: (row) => row[headerSelector[index]],
                button: true,
                cell: PaymentBtn,
                width: "8rem",
                reorder: false,
                wordWrap: "break-word",
            };
        } else if (header === " ") {
            return {
                name: header,
                button: true,
                cell: PendingBtn,
                width: "8rem",
                reorder: true,
                wordWrap: "break-word",
            };
        } else if (header === "PO NO.") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "5rem",
                reorder: true,
            };
        } else if (header === "PO DATE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "SUPPLIER") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "10rem",
                reorder: true,
                left: true,
                wrap: true,
                wordWrap: "break-word",
            };
        } else if (header === "TOTAL") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "BALANCE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "ADDED BY") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "ADDED ON") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "PMT STATUS") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "10rem",
                reorder: true,
            };
        } else if (header === "PREP. BY") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "APPR. BY") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header.includes("PO NO.")) {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                sortable: true,
                width: "8rem",
                reorder: true,
                wrap: true,
            };
        } else if (header === "ORDER DATE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                reorder: true,
                wrap: true,
                sortFunction: (a, b) => {
                    
                    
                    const valueA = parseDate(a.order_request_date);
                    const valueB = parseDate(b.order_request_date);

                    
                    if (valueA === null && valueB === null) {
                        return 0;
                    }
                    if (valueA === null) {
                        return -1;
                    }
                    if (valueB === null) {
                        return 1;
                    }
                    if (valueA < valueB) {
                    return -1;
                    }
                    if (valueA > valueB) {
                    return 1;
                    }
                    return 0;
                },
            };
        } else if (header === "DLVRY DATE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                reorder: true,
                wrap: true,
                sortFunction: (a, b) => {
                    
                    
                    const valueA = parseDate(a.delivery_date);
                    const valueB = parseDate(b.delivery_date);

                    
                    if (valueA === null && valueB === null) {
                        return 0;
                    }
                    if (valueA === null) {
                        return -1;
                    }
                    if (valueB === null) {
                        return 1;
                    }
                    if (valueA < valueB) {
                    return -1;
                    }
                    if (valueA > valueB) {
                    return 1;
                    }
                    return 0;
                },
            };
        } else if (header === "SALES DATE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                reorder: true,
                wrap: true,
                sortFunction: (a, b) => {
                    
                    
                    const valueA = parseDate(a.sales_date);
                    const valueB = parseDate(b.sales_date);

                    
                    if (valueA === null && valueB === null) {
                        return 0;
                    }
                    if (valueA === null) {
                        return -1;
                    }
                    if (valueB === null) {
                        return 1;
                    }
                    if (valueA < valueB) {
                    return -1;
                    }
                    if (valueA > valueB) {
                    return 1;
                    }
                    return 0;
                },
            };
        } else if (header === "DEPOSIT DATE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                reorder: true,
                wrap: true,
                sortFunction: (a, b) => {
                    
                    
                    const valueA = parseDate(a.deposited_on);
                    const valueB = parseDate(b.deposited_on);

                    
                    if (valueA === null && valueB === null) {
                        return 0;
                    }
                    if (valueA === null) {
                        return -1;
                    }
                    if (valueB === null) {
                        return 1;
                    }
                    if (valueA < valueB) {
                    return -1;
                    }
                    if (valueA > valueB) {
                    return 1;
                    }
                    return 0;
                },
            };
        } else if (header === "INV NO.") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "6%",
                reorder: true,
                wrap: true,
                sortFunction: (a, b) => {
                    
                    
                    const valueA = parseFloat(a.id);
                    const valueB = parseFloat(b.id);

                    
                    if (valueA < valueB) {
                    return -1;
                    }
                    if (valueA > valueB) {
                    return 1;
                    }
                    return 0;
                },
            };
        } else if (header === "TOTAL") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                reorder: true,
                wrap: true,
                left: true,
                sortFunction: (a, b) => {
                    
                    
                    const valueA = parseFloat(a.grand_total.replaceAll(',', ''));
                    const valueB = parseFloat(b.grand_total.replaceAll(',', ''));

                    
                    if (valueA < valueB) {
                    return -1;
                    }
                    if (valueA > valueB) {
                    return 1;
                    }
                    return 0;
                },
            };
        } else if (header === "PAID AMNT") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                reorder: true,
                wrap: true,
                sortFunction: (a, b) => {
                    
                    
                    const valueA = parseFloat(a.paid_amount.replaceAll(',', ''));
                    const valueB = parseFloat(b.paid_amount.replaceAll(',', ''));

                    
                    if (valueA < valueB) {
                    return -1;
                    }
                    if (valueA > valueB) {
                    return 1;
                    }
                    return 0;
                },
            };
        } else if (header === "BALANCE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                reorder: true,
                left: true,
                wrap: true,
                sortFunction: (a, b) => {
                    
                    
                    const valueA = parseFloat(a.balance.replaceAll(',', ''));
                    const valueB = parseFloat(b.balance.replaceAll(',', ''));

                    
                    if (valueA < valueB) {
                    return -1;
                    }
                    if (valueA > valueB) {
                    return 1;
                    }
                    return 0;
                },
            };
        } else if (header === "CUR QTY") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "5rem",
                reorder: true,
                right: true,
                wrap: true,
                sortFunction: (a, b) => {
                    
                    
                    const valueA = parseFloat(a.current_qty.replaceAll(',', ''));
                    const valueB = parseFloat(b.current_qty.replaceAll(',', ''));

                    
                    if (valueA < valueB) {
                    return -1;
                    }
                    if (valueA > valueB) {
                    return 1;
                    }
                    return 0;
                },
            };
        } else if (header === "MIN") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                right: true,
                reorder: true,
                wrap: true,
                sortFunction: (a, b) => {
                    
                    
                    const valueA = parseFloat(a.min.replaceAll(',', ''));
                    const valueB = parseFloat(b.min.replaceAll(',', ''));

                    
                    if (valueA < valueB) {
                    return -1;
                    }
                    if (valueA > valueB) {
                    return 1;
                    }
                    return 0;
                },
            };
        } else if (header === "MAX") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                right: true,
                reorder: true,
                wrap: true,
                sortFunction: (a, b) => {
                    
                    
                    const valueA = parseFloat(a.max.replaceAll(',', ''));
                    const valueB = parseFloat(b.max.replaceAll(',', ''));

                    
                    if (valueA < valueB) {
                    return -1;
                    }
                    if (valueA > valueB) {
                    return 1;
                    }
                    return 0;
                },
            };
        } else if (header === "TOTAL GROSS") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                right: true,
                reorder: true,
                wrap: true,
                sortFunction: (a, b) => {
                    
                    
                    const valueA = parseFloat(a.total_gross.replaceAll(',', ''));
                    const valueB = parseFloat(b.total_gross.replaceAll(',', ''));

                    
                    if (valueA < valueB) {
                    return -1;
                    }
                    if (valueA > valueB) {
                    return 1;
                    }
                    return 0;
                },
            };
        } else if (header === "TOTAL REVENUE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                right: true,
                reorder: true,
                wrap: true,
                sortFunction: (a, b) => {
                    
                    
                    const valueA = parseFloat(a.total_revenue.replaceAll(',', ''));
                    const valueB = parseFloat(b.total_revenue.replaceAll(',', ''));

                    
                    if (valueA < valueB) {
                    return -1;
                    }
                    if (valueA > valueB) {
                    return 1;
                    }
                    return 0;
                },
            };
        } else if (header === "TOTAL PAID") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8vw",
                right: true,
                reorder: true,
                wrap: true,
                sortFunction: (a, b) => {
                    
                    
                    const valueA = parseFloat(a.total_paid.replaceAll(',', ''));
                    const valueB = parseFloat(b.total_paid.replaceAll(',', ''));

                    
                    if (valueA < valueB) {
                    return -1;
                    }
                    if (valueA > valueB) {
                    return 1;
                    }
                    return 0;
                },
            };
        } else if (header === "DATE PAID") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                reorder: true,
                wrap: true,
                sortFunction: (a, b) => {
                    
                    
                    const valueA = parseDate(a.payment_date);
                    const valueB = parseDate(b.payment_date);

                    
                    if (valueA === null && valueB === null) {
                        return 0;
                    }
                    if (valueA === null) {
                        return -1;
                    }
                    if (valueB === null) {
                        return 1;
                    }
                    if (valueA < valueB) {
                    return -1;
                    }
                    if (valueA > valueB) {
                    return 1;
                    }
                    return 0;
                },
            };
        } else if (header === "PAID AMT") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8vw",
                right: true,
                reorder: true,
                wrap: true,
                sortFunction: (a, b) => {
                    
                    
                    const valueA = parseFloat(a.paid_amount.replaceAll(',', ''));
                    const valueB = parseFloat(b.paid_amount.replaceAll(',', ''));

                    
                    if (valueA < valueB) {
                    return -1;
                    }
                    if (valueA > valueB) {
                    return 1;
                    }
                    return 0;
                },
            };
        } else if (header === "PHYS COUNT") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                right: true,
                reorder: true,
                wrap: true,
                sortFunction: (a, b) => {
                    
                    
                    const valueA = parseFloat(a.physical_count.replaceAll(',', ''));
                    const valueB = parseFloat(b.physical_count.replaceAll(',', ''));

                    
                    if (valueA < valueB) {
                    return -1;
                    }
                    if (valueA > valueB) {
                    return 1;
                    }
                    return 0;
                },
            };
        } else if (header === "COM COUNT") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8vw",
                right: true,
                reorder: true,
                wrap: true,
                sortFunction: (a, b) => {
                    
                    
                    const valueA = parseFloat(a.computer_count.replaceAll(',', ''));
                    const valueB = parseFloat(b.computer_count.replaceAll(',', ''));

                    
                    if (valueA < valueB) {
                    return -1;
                    }
                    if (valueA > valueB) {
                    return 1;
                    }
                    return 0;
                },
            };
        } else if (header === "TOTAL SALES") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                right: true,
                reorder: true,
                wrap: true,
                sortFunction: (a, b) => {
                    
                    
                    const valueA = parseFloat(a.total_sales.replaceAll(',', ''));
                    const valueB = parseFloat(b.total_sales.replaceAll(',', ''));

                    
                    if (valueA < valueB) {
                    return -1;
                    }
                    if (valueA > valueB) {
                    return 1;
                    }
                    return 0;
                },
            };
        } else if (header === "DEP DATE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                reorder: true,
                wrap: true,
                sortFunction: (a, b) => {
                    
                    
                    const valueA = parseDate(a.deposit_date);
                    const valueB = parseDate(b.deposit_date);

                    
                    if (valueA === null && valueB === null) {
                        return 0;
                    }
                    if (valueA === null) {
                        return -1;
                    }
                    if (valueB === null) {
                        return 1;
                    }
                    if (valueA < valueB) {
                    return -1;
                    }
                    if (valueA > valueB) {
                    return 1;
                    }
                    return 0;
                },
            };
        } else if (header === "CHK DATE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                reorder: true,
                wrap: true,
                sortFunction: (a, b) => {
                    
                    
                    const valueA = parseDate(a.check_date);
                    const valueB = parseDate(b.check_date);

                    
                    if (valueA === null && valueB === null) {
                        return 0;
                    }
                    if (valueA === null) {
                        return -1;
                    }
                    if (valueB === null) {
                        return 1;
                    }
                    if (valueA < valueB) {
                    return -1;
                    }
                    if (valueA > valueB) {
                    return 1;
                    }
                    return 0;
                },
            };
        } else if (header === "PO DATE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                reorder: true,
                wrap: true,
                sortFunction: (a, b) => {
                    
                    
                    const valueA = parseDate(a.purchase_date);
                    const valueB = parseDate(b.purchase_date);

                    
                    if (valueA === null && valueB === null) {
                        return 0;
                    }
                    if (valueA === null) {
                        return -1;
                    }
                    if (valueB === null) {
                        return 1;
                    }
                    if (valueA < valueB) {
                    return -1;
                    }
                    if (valueA > valueB) {
                    return 1;
                    }
                    return 0;
                },
            };
        } else if (header === "DATE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                reorder: true,
                wrap: true,
                sortFunction: (a, b) => {
                    
                    
                    const valueA = parseDate(a.supplies_expense_date || a.date);
                    const valueB = parseDate(b.supplies_expense_date || b.date);

                    
                    if (valueA === null && valueB === null) {
                        return 0;
                    }
                    if (valueA === null) {
                        return -1;
                    }
                    if (valueB === null) {
                        return 1;
                    }
                    if (valueA < valueB) {
                    return -1;
                    }
                    if (valueA > valueB) {
                    return 1;
                    }
                    return 0;
                },
            };
        } else if (header === "ENCODED ON") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                reorder: true,
                wrap: true,
                sortFunction: (a, b) => {
                    
                    
                    const valueA = parseDate(a.encoded_on);
                    const valueB = parseDate(b.encoded_on);

                    
                    if (valueA === null && valueB === null) {
                        return 0;
                    }
                    if (valueA === null) {
                        return -1;
                    }
                    if (valueB === null) {
                        return 1;
                    }
                    if (valueA < valueB) {
                    return -1;
                    }
                    if (valueA > valueB) {
                    return 1;
                    }
                    return 0;
                },
            };
        } else if (header === "MODE" || 
                    header === "REF/CHK" ||
                    header === "CHK DATE" ||
                    header === "DATE PAID" || 
                    header === "PAID AMT" ||
                    header === "CUR QTY" ||
                    header === "ENCODED ON" ||
                    header === "DPST DATE" ||
                    header === "SALES DATE" ||
                    header === "DATE" ||
                    header === "DISBURSEMENT DATE" ||
                    header === "ORDER DATE" ||
                    header === "DLVRY DATE"
                    ) {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                width: "8rem",
                reorder: true,
                sortable: true,
                // wrap: true,
            };
        } else if (header === "*") {
            return {
                name: "",
                selector: (row) => row[headerSelector[index]],
                button: true,
                cell: PaymentBtn,
                width: "5vw",
                reorder: false,
                wrap: true,
            };
        } else if (header === "PO") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                button: true,
                cell: OngoingPOBadges,
                reorder: false,
                width: "8rem",
                left: true,
                wordWrap: "break-word",
            };
        } else if (header.includes("INV NO.")) {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                // left: true,
                sortable: true,
                width: "6%",
                wrap: true,
                reorder: true,
            };
        } else if (header === ".") {
            return {
                name: "",
                selector: (row) => row[headerSelector[index]],
                button: true,
                cell: checkBtn,
                width: "3vw",
                reorder: false,
                wordWrap: "break-word",
            };
        } else if (header === "DEPOSITED") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]].toLowerCase(),
                right: true,
                button: true,
                width: "8vw",
                cell: DepositedBtn,
                reorder: true,
            };
        } else if (header === "TOTAL VARIANCE" || header === "DIFFERENCE" ) {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]].toLowerCase(),
                right: true,
                button: true,
                width: "8vw",
                cell: TotalVarianceBtn,
                reorder: true,
            };
        } else if (header === "CASH VARIANCE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]].toLowerCase(),
                right: true,
                button: true,
                width: "8vw",
                cell: CashVarianceBtn,
                reorder: true,
            };
        } else if (header === "INV VARIANCE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]].toLowerCase(),
                right: true,
                button: true,
                width: "8vw",
                cell: InvVarianceBtn,
                reorder: true,
            };
        } else if (header === "DEPOSIT AMOUNT" || header === "TOTAL DEPOSIT") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                right: true,
                sortable: true,
                width: "11vw",
                reorder: true,
                wrap: true,
            };    
        } else if ((header === "MIN" || 
                header === "MAX" || 
                header.includes("QTY") || 
                header.includes("COUNT") ) && header !== "COUNTED BY") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                right: true,
                sortable: true,
                width: "8vw",
                reorder: true,
                wrap: true,
        };
        } else if (header.includes("SALES") || header.includes("CANCELLED")) {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                right: true,
                sortable: true,
                width: "8vw",
                reorder: true,
                wrap: true,
            };
        } else if (
            header.includes("TOTAL")||
            header.includes("BALANCE")||
            header.includes("AMNT")||
            header.includes("AMOUNT")
            ) {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                sortable: true,
                width: "8rem",
                reorder: true,
                wrap: true,
            };
        }  else if (header.includes("UNIT")) {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                reorder: true,
                wrap: true,
            };
        } else if (header === "ACTIONS") {
            return {
                name: header,
                button: true,
                cell: ActionBtn,
                width: "8rem",
                reorder: false,
                center: true,
            };
        } else if (header === "remarks") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                width: "12vw",
                reorder: false,
                wrap: true,
            };
        } else if (header === "ITEM") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "15rem",
                reorder: true,
                wrap: true,
            };    
        } else if (header === "CASHIER" || header === "PREPARED BY" || header === "BRANCH") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                reorder: true,
                wrap: true,
            };    
        } else if (header === "PMT REF NO" || header === "PMT MODE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                button: true,
                cell: newTabBtn,
                width: "8%",
                reorder: false,
                wrap: true,
            };
        } else if (header === "BRANCH") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                reorder: true,
                wrap: true,
            }; 
        } else if (header.includes("SUBMITTED BY")) {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                reorder: true,
                left: true,
                wrap: true,
            };
        } else if (header.includes("SUBMITTED ON")) {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                reorder: true,
                left: true,
                wrap: true,
            };
        } else if (header.includes("CHECKED BY")) {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                reorder: true,
                left: true,
                wrap: true,
            };
        } else if (header.includes("CHECKED ON")) {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                reorder: true,
                left: true,
                wrap: true,
            };
        } else if (header.includes("PAYROLL RANGE")) {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                reorder: true,
                left: true,
                wrap: true,
            };
        } else if (header.includes("EMPLOYEE NAME")) {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                reorder: true,
                left: true,
                wrap: true,
            };
        } else if (header.includes("PAYEE ID")) {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                reorder: true,
                left: true,
                wrap: true,
            };
        } else if (header.includes("POSTED BY")) {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                reorder: true,
                left: true,
                wrap: true,
            };
        } else if (header.includes("POSTED ON")) {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                reorder: true,
                left: true,
                wrap: true,
            };
        } else if (header.includes("DONE BY")) {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                reorder: true,
                left: true,
                wrap: true,
            };
        } else if (header.includes("DONE ON")) {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                reorder: true,
                left: true,
                wrap: true,
            };  
        } else if (header === "REMARKS") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                reorder: true,
                left: true,
                wrap: true,
            };  
        } else if (header === "BANK") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                reorder: true,
                left: true,
                wrap: true,
            }; 
        } else if (header === "PARTICULARS") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                reorder: true,
                left: true,
                wrap: true,
            }; 
        } else if (header === "REQ BY") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                reorder: true,
                left: true,
                wrap: true,
            }; 
        } else if (header === "CASH IN") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                reorder: true,
                left: true,
                wrap: true,
            };
        } else if (header === "CASH OUT") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                reorder: true,
                left: true,
                wrap: true,
            };
        } else if (header === "COUNTED BY") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                reorder: true,
                left: true,
                wrap: true,
            };  
        } else if (header === "STATUS" || header === "TYPE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                reorder: true,
                wrap: true,
            };    
        } else if (header === "BRANCH STATUS") {
        // } else if (header === "BRANCH STATUS" || header === "INVENTORY VARIANCE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]].toLowerCase(),
                left: true,
                button: true,
                width: "8rem",
                cell: branchStatus,
                reorder: true,
            };
        } 
        // else if (header === "CASH VARIANCE") {
        //     return {
        //         name: header,
        //         selector: (row) => row[headerSelector[index]].toLowerCase(),
        //         left: true,
        //         button: true,
        //         width: "8rem",
        //         cell: cashVariance,
        //         reorder: true,
        //     };
        // } 
        else {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                reorder: true,
                wrap: true,
            };
        }
    });

    const paginationComponentOptions = {
        rowsPerPageText: "",
        noRowsPerPage: true,
    };

    const customStyles = {
        rows: {
            style: {
                minHeight: "5.2vh",
            },
        },
    };
    const rowDisabledCriteria = row => row.isClosedBill;
    return showLoader ? (
        <div className="d-flex justify-content-center my-5">
            <SyncLoader color="var(--primary-color)" size={15} />
        </div>
    ) : (
        <div className="data-table-container data-table-wrapper">
        <DataTable
            responsive
            pagination
            paginationClassName="custom-pagination"
            striped
            columns={columns}
            fixedHeader
            fixedHeaderScrollHeight="50vh"
            data={tableData}
            paginationComponentOptions={paginationComponentOptions}
            noDataComponent={<NoDataPrompt />}
            selectableRows
            selectableRowDisabled={tableType === "order_request" && rowDisabledCriteria}
            selectableRowsVisibleOnly
            customStyles={customStyles}
            onSelectedRowsChange={handleOnCheck}
            className="data-table"

            paginationTotalRows={totalItems} // Total number of items for pagination
            paginationPerPage={itemsPerPage} // Items per page
            paginationServer={true} // Enable server-side pagination
            onChangePage={handlePageChange} // Function to handle page change
            currentPage={currentPage}
            paginationDefaultPage={currentPage} 
        />
        </div>
    );
}
